import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import Link from '@components/link'
import { CtaArrow } from '@components/atoms'
import useStyles, { Logo } from './match-play-full-coverage-link.styles'

const MatchPlayFullCoverageLink = (props) => {
  const {
    fullCoverageUrl,
    logo,
    isEmbedView,
  } = props
  const styles = useStyles({ isEmbedView })

  return (
    <Link externalLink={fullCoverageUrl} className={styles.link}>
      <Box className={styles.root}>
        <Logo image={logo && logo.url} embedview={isEmbedView ? 1 : 0} />
        {isEmbedView && <Divider orientation="vertical" />}
        <Box className={styles.description}>
          <Typography variant="h6">
            View Full Leaderboard
          </Typography>
          <Typography variant="subtitle1">
            Detailed Stats {isEmbedView ? '&' : 'And'} Video On RyderCup.com
          </Typography>
        </Box>
        {isEmbedView
          ? <ArrowForwardIcon style={{ color: '#828282' }} />
          : <CtaArrow color="black" className={styles.cta} />
        }
      </Box>
    </Link>
  )
}

MatchPlayFullCoverageLink.propTypes = {
  fullCoverageUrl: PropTypes.string,
  logo: PropTypes.shape({ url: PropTypes.string }),
  isEmbedView: PropTypes.bool,
}

export default MatchPlayFullCoverageLink
